var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var Reflection = /** @class */ (function () {
    function Reflection() {
    }
    Reflection.getPropertyName = function (propertyFunction) {
        var fn = propertyFunction.toString();
        var classic = /^function\s*\([$_\w\d]+\)\s*\{(?:\s*"use strict";)?\s*(?:[$_\w\d.['"\]+;]+)?\s*return\s+[$_\w\d]+\.([\.$_\w\d]+)\s*;?\s*\}$/;
        //var classic = /^function\s*\([$_\w\d]+\)\s*\{(?:\s*"use strict";)?\s*(?:[$_\w\d.['"\]+;]+)?\s*return\s+[$_\w\d]+\.([$_\w\d]+)\s*;?\s*\}$/;
        var arrow = /^\(?[$_\w\d]+\)?\s*=>\s*[$_\w\d]+\.([$_\w\d]+)$/;
        var regexResult = classic.exec(fn) || arrow.exec(fn);
        return regexResult && regexResult[1] ? regexResult[1].replace(";", "") : undefined;
    };
    Reflection.getPropertyPath = function (propertyFunction) {
        var fn = propertyFunction.toString();
        var classic = /^function\s*\([$_\w\d]+\)\s*\{(?:\s*"use strict";)?\s*(?:[$_\w\d.['"\]+;]+)?\s*return\s*([$_\.\w\d\[\w\d\]]+)\s*;?\s*\}$/;
        var arrow = /^\(?[$_\w\d]+\)?\s*=>\s*([$_\.\w\d\[\w\d\]]+)$/;
        var regexResult = classic.exec(fn) || arrow.exec(fn);
        var parts = regexResult[1].split('.');
        var path = parts.slice(1).join('.');
        return path;
    };
    Reflection.getPropertiesNames = function (propertyFunctions) {
        var properties = [];
        propertyFunctions.forEach(function (x) {
            properties.push(Reflection.getPropertyName(x));
        });
        return properties;
    };
    Reflection.kebabCase = function (str) {
        var kebabCase = str.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase();
        return kebabCase;
    };
    Reflection.unCamelCase = function (propertyGetter) {
        var propertyName = null;
        if (typeof propertyGetter == "function") {
            propertyName = Reflection.getPropertyName(propertyGetter);
        }
        else {
            propertyName = propertyGetter;
        }
        return propertyName
            // insert a space between lower & upper
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            // space before last upper in a sequence followed by lower
            .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
            // uppercase the first character
            .replace(/^./, function (str) { return str.toUpperCase(); });
    };
    Reflection.getPropertiesOfObject = function (object) {
        var e_1, _a;
        var result = [];
        if (!object) {
            return result;
        }
        if (typeof object === "object") {
            try {
                for (var _b = __values(Object.keys(object)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var i = _c.value;
                    result.push(i);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return result;
    };
    return Reflection;
}());
export { Reflection };
var NotifyPropertyChangedBase = /** @class */ (function () {
    function NotifyPropertyChangedBase() {
        this.changes = {};
    }
    NotifyPropertyChangedBase.prototype.onPropertyChanged = function (propertyFunction) {
        var prop = Reflection.getPropertyName(propertyFunction);
        this.changes[prop] = !this.changes[prop];
    };
    return NotifyPropertyChangedBase;
}());
export { NotifyPropertyChangedBase };
